import { render, staticRenderFns } from "./homePix.vue?vue&type=template&id=fcedd6dc"
import script from "./homePix.vue?vue&type=script&lang=ts"
export * from "./homePix.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports